export const URL_BASE_MARKETING_CENTER = "/marketing-center"

export const marketingCenterLinks = [
    {
        linkLabel: 'Latest Posts',
        icon: 'faNewspaper',
        link: URL_BASE_MARKETING_CENTER + "/home",
    },
]